import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import './ToolPage.css'
import './ResumeBuilder.css'
import { trackEvent } from '../../lib/analytics'
import { useDocumentMeta } from '../../hooks/useDocumentMeta'

const emptyExperience = () => ({ role: '', company: '', period: '', description: '' })
const emptyEducation = () => ({ course: '', institution: '', period: '' })

const ResumeBuilder = () => {
  useDocumentMeta({
    title: 'Gerador de Currículo Online | jarder.dev',
    description:
      'Monte seu currículo em um formulário simples, veja a prévia ao ' +
      'vivo e exporte em PDF pela impressão do navegador. Grátis.',
  })

  const [name, setName] = useState('')
  const [title, setTitle] = useState('')
  const [contact, setContact] = useState('')
  const [summary, setSummary] = useState('')
  const [experiences, setExperiences] = useState([emptyExperience()])
  const [educations, setEducations] = useState([emptyEducation()])
  const [skills, setSkills] = useState('')

  const updateExperience = (index, key, value) => {
    setExperiences((current) =>
      current.map((item, i) => (i === index ? { ...item, [key]: value } : item)),
    )
  }
  const updateEducation = (index, key, value) => {
    setEducations((current) =>
      current.map((item, i) => (i === index ? { ...item, [key]: value } : item)),
    )
  }

  const exportPdf = () => {
    trackEvent('tool_generate', { tool: 'resume_builder' })
    window.print()
  }

  const skillList = skills.split(',').map((s) => s.trim()).filter(Boolean)

  return (
    <div className="tool-page resume-page">
      <Link to="/ferramentas" className="tool-back-link no-print">
        ← Todas as ferramentas
      </Link>
      <h1 className="no-print">Gerador de Currículo Online</h1>
      <p className="tool-disclaimer no-print">
        Preencha os campos, veja a prévia abaixo e clique em "Exportar PDF".
        Isso abre a impressão do navegador, escolha "Salvar como PDF".
      </p>

      <div className="resume-builder-grid no-print">
        <div className="tool-field">
          <label htmlFor="name">Nome completo</label>
          <input id="name" type="text" value={name} onChange={(e) => setName(e.target.value)} />
        </div>
        <div className="tool-field">
          <label htmlFor="title">Cargo / área desejada</label>
          <input id="title" type="text" value={title} onChange={(e) => setTitle(e.target.value)} />
        </div>
        <div className="tool-field">
          <label htmlFor="contact">Contato (e-mail, telefone, LinkedIn)</label>
          <input id="contact" type="text" value={contact} onChange={(e) => setContact(e.target.value)} />
        </div>
        <div className="tool-field">
          <label htmlFor="summary">Resumo profissional</label>
          <textarea id="summary" rows="3" value={summary} onChange={(e) => setSummary(e.target.value)} />
        </div>
        <div className="tool-field">
          <label htmlFor="skills">Habilidades (separadas por vírgula)</label>
          <input id="skills" type="text" value={skills} onChange={(e) => setSkills(e.target.value)} />
        </div>

        <h3>Experiências</h3>
        {experiences.map((exp, i) => (
          <div className="resume-entry-fields" key={i}>
            <div className="tool-row">
              <div className="tool-field">
                <label htmlFor={`role-${i}`}>Cargo</label>
                <input id={`role-${i}`} type="text" value={exp.role} onChange={(e) => updateExperience(i, 'role', e.target.value)} />
              </div>
              <div className="tool-field">
                <label htmlFor={`company-${i}`}>Empresa</label>
                <input id={`company-${i}`} type="text" value={exp.company} onChange={(e) => updateExperience(i, 'company', e.target.value)} />
              </div>
              <div className="tool-field">
                <label htmlFor={`period-${i}`}>Período</label>
                <input id={`period-${i}`} type="text" value={exp.period} onChange={(e) => updateExperience(i, 'period', e.target.value)} />
              </div>
            </div>
            <div className="tool-field">
              <label htmlFor={`desc-${i}`}>Descrição</label>
              <textarea id={`desc-${i}`} rows="2" value={exp.description} onChange={(e) => updateExperience(i, 'description', e.target.value)} />
            </div>
            {experiences.length > 1 && (
              <button type="button" className="tool-button tool-button-secondary" onClick={() => setExperiences((c) => c.filter((_, idx) => idx !== i))}>
                Remover experiência
              </button>
            )}
          </div>
        ))}
        <button type="button" className="tool-button tool-button-secondary" onClick={() => setExperiences((c) => [...c, emptyExperience()])}>
          + Adicionar experiência
        </button>

        <h3>Formação</h3>
        {educations.map((edu, i) => (
          <div className="tool-row" key={i}>
            <div className="tool-field">
              <label htmlFor={`course-${i}`}>Curso</label>
              <input id={`course-${i}`} type="text" value={edu.course} onChange={(e) => updateEducation(i, 'course', e.target.value)} />
            </div>
            <div className="tool-field">
              <label htmlFor={`institution-${i}`}>Instituição</label>
              <input id={`institution-${i}`} type="text" value={edu.institution} onChange={(e) => updateEducation(i, 'institution', e.target.value)} />
            </div>
            <div className="tool-field">
              <label htmlFor={`edu-period-${i}`}>Período</label>
              <input id={`edu-period-${i}`} type="text" value={edu.period} onChange={(e) => updateEducation(i, 'period', e.target.value)} />
            </div>
            {educations.length > 1 && (
              <button type="button" className="tool-button tool-button-secondary" onClick={() => setEducations((c) => c.filter((_, idx) => idx !== i))}>
                Remover
              </button>
            )}
          </div>
        ))}
        <button type="button" className="tool-button tool-button-secondary" onClick={() => setEducations((c) => [...c, emptyEducation()])}>
          + Adicionar formação
        </button>
      </div>

      <button type="button" className="tool-button no-print" onClick={exportPdf} style={{ margin: '24px 0' }}>
        Exportar PDF
      </button>

      <div className="resume-preview" id="resume-preview">
        <h1>{name || 'Seu Nome'}</h1>
        {title && <p className="resume-preview-title">{title}</p>}
        {contact && <p className="resume-preview-contact">{contact}</p>}
        {summary && (
          <section>
            <h2>Resumo</h2>
            <p>{summary}</p>
          </section>
        )}
        {experiences.some((e) => e.role || e.company) && (
          <section>
            <h2>Experiência</h2>
            {experiences.map((exp, i) => (
              (exp.role || exp.company) && (
                <div className="resume-preview-entry" key={i}>
                  <strong>{exp.role}</strong> {exp.company && `na ${exp.company}`}
                  {exp.period && <span className="resume-preview-period"> ({exp.period})</span>}
                  {exp.description && <p>{exp.description}</p>}
                </div>
              )
            ))}
          </section>
        )}
        {educations.some((e) => e.course || e.institution) && (
          <section>
            <h2>Formação</h2>
            {educations.map((edu, i) => (
              (edu.course || edu.institution) && (
                <div className="resume-preview-entry" key={i}>
                  <strong>{edu.course}</strong> {edu.institution && `na ${edu.institution}`}
                  {edu.period && <span className="resume-preview-period"> ({edu.period})</span>}
                </div>
              )
            ))}
          </section>
        )}
        {skillList.length > 0 && (
          <section>
            <h2>Habilidades</h2>
            <p>{skillList.join(' · ')}</p>
          </section>
        )}
      </div>

      <div className="tool-info-section no-print">
        <h2>Como exportar em PDF</h2>
        <p>
          O botão "Exportar PDF" abre a janela de impressão do seu
          navegador (Ctrl+P) já mostrando só a prévia do currículo, sem
          os campos de formulário. Escolha o destino "Salvar como PDF"
          (ou "Microsoft Print to PDF" no Windows) em vez de uma
          impressora física. Tudo é montado no seu navegador  nenhum
          dado do currículo é enviado a um servidor.
        </p>
      </div>
    </div>
  )
}

export default ResumeBuilder
